//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed, defineComponent, ref, useContext } from '@nuxtjs/composition-api'
const img = require('@/assets/img/icon/dev-icon.png')

export default defineComponent({
  setup () {
    const { app } = useContext()

    const isTestEnvironment = computed(() => {
      return process.env.NODE_ENV !== 'production'
    })

    const switchToV2 = () => {
      // Set cookie to v2
      app.$cookies.set('ggo_version', 'v2', {
        path: '/',
        maxAge: 60 * 60 * 24 * 30, // 30 days
      })

      // Refresh the page
      window.location.reload()
    }

    const devModelOpen = ref(false)
    const handleDevClick = () => {
      devModelOpen.value = true
    }
    const handleDevModalClose = () => {
      devModelOpen.value = false
    }

    return {
      img,
      isTestEnvironment,
      switchToV2,
      devModelOpen,
      handleDevClick,
      handleDevModalClose,
    }
  },
})
